<template>
    <div class="InternationalLogistics">
        <div class="InternationalLogistics_top">
            <h3>国际物流排查</h3>
            <div style="float: right">
                <el-button type="warning" @click="showFilter = !showFilter">{{ showFilter ? '隐藏筛选条件' : '显示筛选条件'
                }}</el-button>
            </div>
        </div>
        <el-collapse-transition>
            <div v-show="showFilter">
                <el-form :model="ruleForm" ref="ruleForm" :label-position="labelPosition" inline
                    class="custom-formScreen">
                    <el-form-item label="开始日期" prop="startTime">
                        <el-date-picker v-model="ruleForm.startTime" align="right" type="datetime" placeholder="选择日期"
                            format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="endTime">
                        <el-date-picker v-model="ruleForm.endTime" align="right" type="datetime" placeholder="选择日期"
                            format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="选择子公司" v-if="str.type != 3">
                        <el-select v-model="ruleForm.subsidiaryArray" multiple filterable clearable placeholder="请选择">
                            <el-option v-for="item in subsidiaryList" :key="item.id" :label="item.companyFullName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="拦截状态" prop="outInterceptStatus">
                        <el-select v-model="outInterceptStatus" placeholder="请选择" @change="chanOutInterceptStatus"
                            filterable clearable>
                            <el-option v-for="(item, index) in outInterceptStatusValue" :key="index" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-row>
                        <el-form-item label="备注" prop="remark" style="margin-right: 20px">
                            <el-input placeholder="请输入备注" v-model.trim="ruleForm.remark"></el-input>
                        </el-form-item>
                        <el-form-item prop="input" label="多个订单号" style="width: 30%">
                            <el-input v-model.trim="orderStrList" style="width: calc(100% - 20px);"
                                placeholder="请输入多个订单号，空格分开"></el-input>
                        </el-form-item>
                        <el-form-item prop="input" label="多个运单号" style="width: 40%">
                            <el-input v-model.trim="waybillStrList" style="width: calc(100% - 140px);"
                                placeholder="请输入多个运单号，空格分开"></el-input>
                            <el-button type="primary" style="margin-left: 10px;" @click="Search2">搜索</el-button>
                            <el-button type="primary" @click="searchReset">重置</el-button>
                        </el-form-item>
                    </el-row>
                    <el-form-item label="包裹状态:" style="width:100%; ">
                        <el-radio-group v-model="ruleForm.mainStatus" @change="mainStatusChange">
                            <template v-for="item in this.colorList1">
                                <el-radio :key="item.id" :label="item.itemTypeName"
                                    @click.native.prevent="cancelSelect(item.itemTypeName, 'mainStatus')"
                                    :style="{ color: item.itemName }">{{
                                        item.itemTypeName
                                    }}</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="判定结果:" style="width:100%;">
                        <el-radio-group v-model="ruleForm.judgeResult" @change="judgeResultChange">
                            <template v-for="item in this.colorList2">
                                <el-radio :key="item.id" :label="item.itemTypeName"
                                    @click.native.prevent="cancelSelect(item.itemTypeName, 'judgeResult')">{{
                                        item.itemTypeName
                                    }}</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="订单标记:" style="width:100%;">
                        <el-radio-group v-model="ruleForm.orderMark" @change="orderMarkChange">
                            <template v-for="item in this.colorList3">
                                <el-radio :key="item.id" :label="item.itemTypeId"
                                    @click.native.prevent="cancelSelect(item.itemTypeId, 'orderMark')">{{
                                        item.itemTypeName
                                    }}</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="处理状态:" style="width:100%;">
                        <el-radio-group v-model="ruleForm.handleStatus" @change="handleStatusChange">
                            <template v-for="item in this.colorList4">
                                <el-radio :key="item.id" :label="item.itemTypeName"
                                    @click.native.prevent="cancelSelect(item.itemTypeName, 'handleStatus')"
                                    :style="{ color: item.itemName }">{{
                                        item.itemTypeName
                                    }}</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="订单类型:" style="width:100%;">
                        <el-radio-group v-model="ruleForm.orderType" @change="orderTypeChange">
                            <template v-for="item in this.colorList5">
                                <el-radio :key="item.id" :label="item.itemTypeId"
                                    @click.native.prevent="cancelSelect(item.itemTypeId, 'orderType')">{{
                                        item.itemTypeName
                                    }}</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>

                </el-form>
            </div>
        </el-collapse-transition>

        <div class="order_list" v-loading="loading" element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div style="margin-right:20px;">
                <el-dropdown trigger="click" @command="handleCommand1">
                    <el-button type="primary" :disabled="colordisabled">
                        订单标记修改<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <div v-for="item in this.colorList3">
                            <el-dropdown-item :command="item.itemTypeId">{{
                                item.itemTypeName
                                }}</el-dropdown-item>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown style="margin-left:20px" trigger="click" @command="handleCommand2">
                    <el-button type="primary" :disabled="colordisabled">
                        处理状态修改<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <div v-for="item in this.colorList4">
                            <el-dropdown-item :command="item.itemTypeId">{{
                                item.itemTypeName
                                }}</el-dropdown-item>
                        </div>
                    </el-dropdown-menu>

                    <el-button type="primary" style="margin-left:20px" :disabled="colordisabled" @click="handleSync">
                        修改备注
                    </el-button>

                    <el-button type="primary" style="margin-left:20px" :disabled=false @click="exportTrackInfo">
                        导出
                    </el-button>
                </el-dropdown>

            </div>
            <el-table border :header-cell-style="{ textAlign: 'center' }" :data="tableData"
                style="width: 100%;margin-bottom:50px;margin-top:20px;" @selection-change="handleSelectionChange"
                v-loading="loadingStatus">
                <el-table-column type="selection" width="55" align="center">
                </el-table-column>
                <el-table-column label="国际运单号" prop="number" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.number }}</p>
                        <el-row type="flex" align="middle">
                            <el-popover placement="top" width="500" trigger="click"
                                @show="popoverShows(scope.row.orderId)">
                                <template slot="reference">
                                    <i class="el-icon-tickets"
                                        style="margin-top: 5px; font-size: 17px;cursor: pointer;"></i>
                                    <!-- <el-button type="primary">日志</el-button> -->
                                </template>
                                <el-timeline>
                                    <el-timeline-item v-for="(activity, index) in activities" :key="index"
                                        :timestamp="activity.createTime">
                                        {{ activity.operateName }}
                                    </el-timeline-item>
                                </el-timeline>
                            </el-popover>
                        </el-row>
                    </template>

                </el-table-column>
                <el-table-column label="图片" width="140" align="center">
                    <template slot-scope="scope">
                        <div class="scope_img" slot="reference" @click="handlePreviewImages(scope.row)">
                            <img :src="Array.isArray(scope.row.imageUrls) ? scope.row.imageUrls[0] : scope.row.imageUrls"
                                alt />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="订单号" width="250" align="left">
                    <template slot-scope="scope">
                        <p>店铺：{{ scope.row.shopName }}</p>
                        <p>订单号：{{ scope.row.amazonOrderId }}</p>
                        <p>订单ID：{{ scope.row.orderId }}</p>
                        <el-tag style="margin-right:5px;" v-for="tag in scope.row.orderMarkItems" :color="tag.itemName"
                            :key="tag.id" effect="dark" size="mini" :type="tag.type">
                            {{ tag.itemTypeName }}
                        </el-tag>
                        <!-- <el-row type="flex" align="middle"> -->
                        <el-tag style="margin-right:5px;" v-if="scope.row.outInterceptStatus == 1" color="red"
                            effect="dark" size="mini">
                            拦截
                        </el-tag>
                        <el-tag style="margin-right:5px;"
                            :color="scope.row.orderType ? colorList5[scope.row.orderType].itemName : '#fff'"
                            effect="dark" size="mini" v-if="scope.row.orderType">
                            {{ scope.row.orderType ? colorList5[scope.row.orderType].itemTypeName : '' }}
                        </el-tag>
                        <!-- </el-row> -->
                    </template>
                </el-table-column>
                <el-table-column label="包裹状态" prop="mainStatus" align="center">
                    <template slot-scope="scope">
                        <span
                            :style="{ color: scope.row.mainStatus ? colorList1.find(item => item.itemTypeName === scope.row.mainStatus).itemName : '#fff' }">{{
                                scope.row.mainStatus }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="判定结果" prop="judgeResult" align="center"></el-table-column>
                <el-table-column label="备注" prop="remark" align="center"></el-table-column>
                <el-table-column label="最新事件" width="250" align="left">
                    <template slot-scope="scope">
                        <p v-show="scope.row.latestEventJson.description">{{ scope.row.latestEventJson.description }}
                        </p>
                        <p v-show="scope.row.latestEventJson.time_iso" style="color: #909399; font-size: 12px;">
                            {{ scope.row.latestEventJson.time_iso }}
                            <el-tooltip :content="`距离此事件已过去 ${calculateDaysAfterLastUpdate(scope.row)} 天`" placement="top">
                                <i class="el-icon-time" style="cursor: pointer; margin-left: 5px;"></i>
                            </el-tooltip>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="时效" align="center">
                    <template slot-scope="scope">
                        <p>订单: {{ scope.row.daysAfterOrder }} 天</p>
                        <p>运输: {{ scope.row.daysOfTransit }} 天</p>
                        <p>妥投: {{ scope.row.daysOfTransitDone }} 天</p>
                        <p>无更新: {{ calculateDaysAfterLastUpdate(scope.row) }} 天 <el-tooltip content="基于最新事件时间实时计算" placement="top"><i class="el-icon-info" style="color: #909399; cursor: pointer;"></i></el-tooltip></p>
                    </template>

                </el-table-column>
                <el-table-column label="收件国家" prop="recipientCountry" width="100" align="center"></el-table-column>
                <el-table-column label="处理状态" prop="handleStatus" align="center">
                    <template slot-scope="scope">
                        <span
                            :style="{ color: scope.row.handleStatus ? colorList4.find(item => item.itemTypeName === scope.row.handleStatus).itemName : '#fff' }">{{
                                scope.row.handleStatus }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[20, 50, 100, 200, 400]" :page-size="size" :current-page="currentpage" :total="total"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
            </div>
        </div>
        <el-dialog title="图片预览" :visible.sync="imagePreviewVisible" width="80%" center>
            <div class="image-preview-container">
                <div v-for="(url, index) in previewImages" :key="index" class="preview-image-item">
                    <img :src="url" alt="产品图片" />
                </div>
            </div>
        </el-dialog>
        <el-dialog title="修改备注" :visible.sync="dialog" width="30%">
            <el-row type="flex" align="middle">
                <div>
                    <el-input placeholder="请输入备注" v-model="remarkUpdate"
                        style="width:300px;margin-left: 10px;"></el-input>
                </div>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="updateRemark" :loading="issloading">确 定</el-button>
            </span>
        </el-dialog>
    </div>



</template>
<script>
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
    name: "InternationalLogistics",
    data() {
        return {
            ruleForm: {
                countryMark: '', // 国家
                remark: '',
                mainStatus: '',
                judgeResult: '',
                orderMark: '',
                handleStatus: '',
                orderType: '',
                startTime: '',
                endTime: '',
                subsidiaryArray: [],
            },
            subsidiaryList: [],
            currentpage: 1,
            pagesize: 20,
            size: 20,
            total: 0,
            loading: false,
            input: '',
            tableData: [],
            popoverText: '查询中...',
            showFilter: true,
            orderStrList: '',
            waybillStrList: '',
            labelPosition: 'right',
            colorList1: [],
            colorList2: [],
            colorList3: [],
            colorList4: [],
            colorList5: [],
            colordisabled: true,
            multipleSelection: [],

            loadingStatus: false,
            dialog: false,
            remarkUpdate: '',
            issloading: false,
            activities: [],
            //外部拦截状态
            outInterceptStatus: '',
            outInterceptStatusValue: [
                {
                    value: 1,
                    label: '拦截',
                },
            ],

            imagePreviewVisible: false,
            previewImages: [],
        }
    },
    created() {
        this.str = JSON.parse(localStorage.getItem('role'))
        this.mainStatusTag()
        this.judgeResultTag()
        this.orderMarkTag()
        this.handleStatusTag()
        this.ordertypeTag()
        this.init()
        this.SubsidiaryAjax()
    },
    methods: {
        exportTrackInfo() {
            // console.log("导出17物流信息");
            // window.open(`${Baseurl}/track17RegisterController/exportTrack17PageInfo`, 'target');
            var begin = this.ruleForm.startTime
            if (begin == null || begin == '') {
                begin = ''
            } else {
                begin =
                    new Date(this.ruleForm.startTime)
                        .toLocaleDateString()
                        .replace(/\//g, '-') +
                    ' ' +
                    new Date(this.ruleForm.startTime)
                        .toTimeString()
                        .substr(0, 8)
            }
            var end = this.ruleForm.endTime
            if (end == null || end == '') {
                end = ''
            } else {
                end =
                    new Date(this.ruleForm.endTime)
                        .toLocaleDateString()
                        .replace(/\//g, '-') +
                    ' ' +
                    new Date(this.ruleForm.endTime).toTimeString().substr(0, 8)
            }
            const requestData = {
                startTime: begin,
                endTime: end,
                orderMark: this.ruleForm.orderMark,
                mainStatus: this.ruleForm.mainStatus,
                judgeResult: this.ruleForm.judgeResult,
                remark: this.ruleForm.remark,
                handleStatus: this.ruleForm.handleStatus,
                orderType: this.ruleForm.orderType,
                companyIds: this.ruleForm.subsidiaryArray,
                outInterceptStatus: this.outInterceptStatus,
            };
            if (this.orderStrList) {
                this.$set(requestData, 'orderStrList', this.orderStrList.split(' '))
            }

            if (this.waybillStrList) {
                this.$set(requestData, 'waybillStrList', this.waybillStrList.split(' '))
            }
            if (this.str.type == 3) {
                requestData.rid = this.str.rid
            }
            fetch(`${Baseurl}/track17RegisterController/exportTrack17PageInfo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': localStorage.getItem('token'),
                },
                body: JSON.stringify(requestData),
            })
                .then(response => {
                    // 检查请求是否成功
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    console.log(response.headers);
                    // 获取文件名
                    const fileNameHeader = response.headers.get('Content-disposition');
                    const fileNameMatch = fileNameHeader && fileNameHeader.match(/filename="(.+?)"/);

                    // 将响应的文件流作为 Blob 对象处理
                    return response.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob);

                        // 创建一个<a>元素，设置下载链接，并模拟点击
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = fileNameMatch ? fileNameMatch[1] : 'download.xls';
                        document.body.appendChild(a);
                        a.click();

                        // 移除创建的<a>元素
                        document.body.removeChild(a);

                        // 释放URL对象
                        window.URL.revokeObjectURL(url);
                    });
                })
                .catch(error => console.error('Error:', error));
        },

        SubsidiaryAjax() {
            ajaxPost(Baseurl + "unknownManageController/selectAllSubCompany").then(res => {
                if (res.data.code == 200) {
                    this.subsidiaryList = res.data.data
                }
            });
        },
        handleCommand1(val) {
            var obj = {
                amazonOrderIdList: this.multipleSelection.map(item => item.amazonOrderId),
                orderMarkId: val,
            }
            console.log(obj);
            ajaxPost(Baseurl + 'track17RegisterController/updateOrderMarkByAmazonOrderIds', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        this.init()
                    } else {
                        this.$message.error(res.data.data)
                    }
                }
            )
        },
        handleCommand2(val) {
            var obj = {
                ids: this.multipleSelection.map(item => item.id),
                handleStatus: val,
            }
            console.log(obj);
            ajaxPost(Baseurl + 'track17RegisterController/updateHandleStatus', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        this.init()
                    } else {
                        this.$message.error(res.data.data)
                    }
                }
            )
        },
        init() {
            this.loadingStatus = true
            this.Search()
        },
        mainStatusChange(val) {
            this.mainStatus = val
            this.Search()
        },
        judgeResultChange(val) {
            this.judgeResult = val
            this.Search()
        },
        orderMarkChange(val) {
            this.orderMark = val
            this.Search()
        },
        handleStatusChange(val) {
            this.handleStatus = val
            this.Search()
        },
        chanOutInterceptStatus(val) {
            this.outInterceptStatus = val
            this.Search()
        },
        orderTypeChange(val) {
            this.orderType = val
            this.Search()
        },

        Search2() {
            this.currentpage = 1
            this.Search()
        },

        // 重置
        searchReset() {
            this.ruleForm.countryMark = ''
            this.ruleForm.remark = ''
            this.ruleForm.mainStatus = ''
            this.ruleForm.judgeResult = ''
            this.ruleForm.orderMark = ''
            this.ruleForm.handleStatus = ''
            this.ruleForm.orderType = ''
            this.ruleForm.subsidiaryArray = []
            this.orderStrList = ''
            this.waybillStrList = ''
            this.currentpage = 1
            this.size = 20
            this.ruleForm.startTime = ''
            this.ruleForm.endTime = ''
            this.outInterceptStatus = ''
            this.init()
        },

        /**
         * 取消选中
         */
        cancelSelect(e, label) {
            e === this.ruleForm[label] ? this.ruleForm[label] = '' : this.ruleForm[label] = e
            if (label == 'mainStatus') {
                this.mainStatusChange(this.ruleForm[label])
            }
            if (label == 'judgeResult') {
                this.judgeResultChange(this.ruleForm[label])
            }
            if (label == 'orderMark') {
                this.orderMarkChange(this.ruleForm[label])
            }
            if (label == 'handleStatus') {
                this.handleStatusChange(this.ruleForm[label])
            }
            if (label == 'orderType') {
                this.orderTypeChange(this.ruleForm[label])
            }
        },

        //包裹状态
        mainStatusTag() {
            var obj = { itemCode: '17track_main_status' }
            ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        this.colorList1 = res.data.data
                        this.sortByKey(this.colorList1, 'id')
                    }
                }
            )
        },
        //判定结果
        judgeResultTag() {
            var obj = { itemCode: '17track_judge_result' }
            ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        this.colorList2 = res.data.data
                        this.sortByKey(this.colorList2, 'id')
                    }
                }
            )
        },
        //订单标记
        orderMarkTag() {
            var obj = { itemCode: 'HYXUN0000010' }
            ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        this.colorList3 = res.data.data
                        this.sortByKey(this.colorList3, 'itemTypeIdInteger')
                    }
                }
            )
        },
        //处理状态
        handleStatusTag() {
            var obj = { itemCode: '17track_handle_status' }
            ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        this.colorList4 = res.data.data
                        this.sortByKey(this.colorList4, 'id')
                    }
                }
            )
        },
        //订单类型标签
        ordertypeTag() {
            var obj = { itemCode: 'HYXUN0000015' }
            ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
                (res) => {
                    if (res.data.code == 200) {
                        let obj = {};
                        res.data.data.forEach(item => {
                            obj[item.itemTypeId] = item
                        });
                        this.colorList5 = obj;
                    }
                }
            )
        },

        sortByKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key]
                var y = b[key]
                return x < y ? -1 : x > y ? 1 : 0
            })
        },

        handleSizeChange(val) {
            this.size = val
            this.Search()
        },
        handleCurrentChange(val) {
            this.currentpage = val
            this.Search()
        },

        Search() {
            var begin = this.ruleForm.startTime
            if (begin == null || begin == '') {
                begin = ''
            } else {
                begin =
                    new Date(this.ruleForm.startTime)
                        .toLocaleDateString()
                        .replace(/\//g, '-') +
                    ' ' +
                    new Date(this.ruleForm.startTime)
                        .toTimeString()
                        .substr(0, 8)
            }
            var end = this.ruleForm.endTime
            if (end == null || end == '') {
                end = ''
            } else {
                end =
                    new Date(this.ruleForm.endTime)
                        .toLocaleDateString()
                        .replace(/\//g, '-') +
                    ' ' +
                    new Date(this.ruleForm.endTime).toTimeString().substr(0, 8)
            }
            this.loadingStatus = true
            var searchobj = {
                page: this.currentpage,
                size: this.size,
                startTime: begin,
                endTime: end,
                orderMark: this.ruleForm.orderMark,
                mainStatus: this.ruleForm.mainStatus,
                judgeResult: this.ruleForm.judgeResult,
                remark: this.ruleForm.remark,
                handleStatus: this.ruleForm.handleStatus,
                orderType: this.ruleForm.orderType,
                companyIds: this.ruleForm.subsidiaryArray,
                outInterceptStatus: this.outInterceptStatus,
            }
            if (this.str.type == 3) {
                searchobj.rid = this.str.rid
            }
            if (this.orderStrList) {
                this.$set(searchobj, 'orderStrList', this.orderStrList.split(' '))
            }
            if (this.waybillStrList) {
                this.$set(searchobj, 'waybillStrList', this.waybillStrList.split(' '))
            }
            ajaxPost(Baseurl + 'track17RegisterController/selectTrack17PageInfo', searchobj).then(
                (res) => {
                    this.loadingStatus = false
                    const { code, message } = res.data
                    if (code === 200) {
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    } else if (code === 500) {
                        this.$message.error(message)
                    }
                }
            )
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
            console.log(this.multipleSelection);
            if (this.multipleSelection === []) {
                this.colordisabled = true
            } else if (this.multipleSelection.length == 0) {
                this.colordisabled = true
            } else {
                this.colordisabled = false
            }
        },

        handleSync() {
            this.dialog = true
        },
        handleCancel() {
            this.$message('已取消')
            this.dialog = false
            this.remarkUpdate = ''
        },
        // 修改备注
        updateRemark() {
            if (this.remarkUpdate) {
                this.issloading = true
                let list = []
                if (this.multipleSelection && this.multipleSelection.length) {
                    this.multipleSelection.map(item => {
                        let obj = {
                            id: item.id,
                            roleId: this.str.rid,
                            amazonOrderId: item.amazonOrderId,
                            orderId: item.orderId,
                            remark: this.remarkUpdate,
                            number: item.number
                        }
                        list.push(obj)
                    })

                    ajaxPost(
                        Baseurl + 'track17RegisterController/updateRemark',
                        list
                    ).then((res) => {
                        if (res.data.code == 200) {
                            this.issloading = false
                            this.dialog = false
                            this.remarkUpdate = ''
                            this.init()
                        } else {
                            this.$message.error(res.data.data)
                        }
                    }
                    )
                }


            } else {
                this.$message.error('请检查信息是否完整')
            }
        },

        // 获取备注修改日志
        popoverShows(orderId) {
            ajaxPost(Baseurl + 'logisticsController/getOrderOperateLog', { orderId }).then((res) => {
                if (res.data.code == 200) {
                    this.activities = res.data.data.filter(item => item.type === 50)
                    console.log(this.activities);
                }
            })
        },

        handlePreviewImages(row) {
            if (!row.imageUrls) return;
            this.previewImages = Array.isArray(row.imageUrls) ? row.imageUrls : [row.imageUrls];
            this.imagePreviewVisible = true;
        },

        // 计算无更新天数（基于最新事件时间实时计算）
        calculateDaysAfterLastUpdate(row) {
            if (!row.latestEventJson || !row.latestEventJson.time_utc) {
                return row.daysAfterLastUpdate || '-';
            }
            try {
                const lastUpdateTime = new Date(row.latestEventJson.time_utc);
                const now = new Date();
                const diffDays = Math.floor((now - lastUpdateTime) / (1000 * 60 * 60 * 24));
                return diffDays >= 0 ? diffDays : row.daysAfterLastUpdate || '-';
            } catch (e) {
                return row.daysAfterLastUpdate || '-';
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.InternationalLogistics {
    width: 98%;
    position: relative;

    .InternationalLogistics_top {
        overflow: hidden;
        border-bottom: 1px #eee solid;

        h3 {
            float: left;
            margin-bottom: 20px;
        }

    }

    ::v-deep {
        .el-form-item__label {
            width: 90px;
            text-align: right;
        }
    }

    .page {
        position: fixed;
        width: 100%;
        bottom: 0;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        z-index: 99;
    }
}

.custom-formScreen {
    ::v-deep {
        .el-form-item {
            width: 20%;
            margin-right: 0;
        }

        .el-form-item__content {
            width: calc(100% - 5vw);

            .el-select,
            .el-date-editor,
            .el-input {
                width: 100%;
            }
        }
    }
}

.scope_img {
    width: 55px;
    height: 55px;
    margin: 0 auto;
    cursor: pointer;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.image-preview-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;

    .preview-image-item {
        width: 300px;
        height: 300px;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border: 1px solid #eee;
        }
    }
}
</style>